import { revokeSession } from "../../helpers/SessionHelper";
import { ActivityType } from "../../models/ActivityType";
import { PlaygroundClientType } from "../../models/PlaygroundClientType";
import { PlaygroundType } from "../../models/PlaygroundType";
import { ActivitiesUpdateRequest } from "../../models/request/ActivitiesUpdateRequest";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getActivities = (
  sessionToken: string
): Promise<Array<ActivityType>> => {
  return fetch(BASE_URL + "/activities", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "X-ACCESS-TOKEN": sessionToken,
    },
  })
    .then((response) => {
      if (response.status !== 200) {
        revokeSession();
        return;
      }
      return response.json();
    })
    .then((response) => response);
};

export const setActivities = (
  sessionToken: string,
  playground: PlaygroundClientType | PlaygroundType,
  activitiesUpdate: ActivitiesUpdateRequest
): Promise<[]> => {
  return fetch(BASE_URL + "/playgrounds/" + playground.id + "/setActivities", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-ACCESS-TOKEN": sessionToken,
    },
    body: JSON.stringify(activitiesUpdate),
  })
    .then((response) => {
      if (response.status !== 200) {
        revokeSession();
        return;
      }
      return response.json();
    })
    .then((response) => response);
};
